import { SessionReportPage } from './SessionReportPage';
export default SessionReportPage;
